import React, { useState, useEffect } from 'react'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Message } from 'rsuite'
import ProgressObjective from './ProgressObjective'
import ProgressResultsOfOperations from './ProgressResultsOfOperations'

export default function PerformanceResultsWidget({
  schema: _schema,
  isRole,
  isReadOnly,
  period,
  renderMentionOfmentor,
  projectCode,
  projectVersionId,
  installmentPlanId,
  disabled,
  progressReportsId,
  setProgressReportsId = () => {},
  isRenderMentionOfmentor,
  projectStartDate,
  projectEndDate,
  ...props
}) {
  const [formSchema, setFormSchema] = useState(_schema)

  useEffect(() => {
    setFormSchema(_schema)
  }, [_schema])

  return (
    <>
      {formSchema && (
        <Panel shaded header={formSchema.header} collapsible defaultExpanded>
          <ProgressObjective
            schema={formSchema.objective}
            isRole={isRole}
            isReadOnly={isReadOnly}
            period={period}
            projectCode={projectCode}
            projectVersionId={projectVersionId}
            installmentPlanId={installmentPlanId}
            disabled={disabled}
            progressReportsId={progressReportsId}
            setProgressReportsId={setProgressReportsId}
            isRenderMentionOfmentor={isRenderMentionOfmentor}
          />
          <br />
          <ProgressResultsOfOperations
            schema={formSchema.resultsOfOperations}
            isRole={isRole}
            renderMentionOfmentor={renderMentionOfmentor}
            isReadOnly={isReadOnly}
            period={period}
            projectCode={projectCode}
            projectVersionId={projectVersionId}
            installmentPlanId={installmentPlanId}
            disabled={disabled}
            progressReportsId={progressReportsId}
            setProgressReportsId={setProgressReportsId}
            projectStartDate={projectStartDate}
            projectEndDate={projectEndDate}
          />
        </Panel>
      )}
    </>
  )
}
